import script from "./form-fieldset-slot.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-fieldset-slot.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__